<template>
    <div>
        <!--<Modal v-model="$parent.areaListDialog" :mask-closable="false">-->
            <div slot="header"><strong style="font-size: 16px">Area ({{areaArr.length}})</strong>
                <Icon type="md-add-circle" class="add-icon-area"
                      :style="(!city.city || !areaGroup.name)?'pointer-events:none;':''" @click="onAddArea"></Icon>
            </div>
            <div>
                <Table :columns="areaHeaders" :data="areaArr" max-height="400">
                    <template slot-scope="{ row }" slot="action">
                        <Icon type="md-create" @click="onEditArea(row)"></Icon>&nbsp;
                        <Icon type="md-close" @click="onDeleteArea(row.id)"></Icon>
                    </template>
                </Table>
            </div>
            <!--<div slot="footer">-->
                <!--<Button style="background: #999999; color: white;font-weight: bolder" @click="$parent.areaListDialog=false">CLOSE</Button>-->
            <!--</div>-->
        <!--</Modal>-->

        <Modal v-model="addAreaDialog" :mask-closable="false" width="450" draggable>
            <div slot="header"><strong>{{editMode?'Edit':'New'}} Area</strong></div>
            <div>
                <Form :model="areaForm" :rules="ruleAreaForm" ref="areaForm" :label-width="110">
                    <FormItem prop="area" label="Area">
                        <Input v-model="areaForm.area"/>
                    </FormItem>

                    <FormItem prop="cityName" label="City">
                        <AutoComplete v-model="areaForm.cityName" v-if="addAreaDialog">
                            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                    :key="index" :value="cityObj.city">
                              <div class="ivu-select-item-div" @click="areaForm.cityId=cityObj.id">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                    </FormItem>

                    <FormItem prop="groupName" label="Area Group">
                        <AutoComplete v-model="areaForm.groupName" v-if="addAreaDialog">
                            <Option v-for="(groupObj,index) in groupArr" :label="groupObj.name"
                                    :key="index" :value="groupObj.name">
                                <div class="ivu-select-item-div" @click="areaForm.groupId=groupObj.id">{{groupObj.name}}</div>
                            </Option>
                        </AutoComplete>
                    </FormItem>

                </Form>
            </div>
            <div slot="footer">
                <Button v-if="!editMode" type="primary" style="font-weight: bolder" @click="addArea" :loading="loading">
                    <span v-if="!loading">SAVE</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button v-if="editMode" type="primary" style="font-weight: bolder" @click="modifyArea">UPDATE</Button>
                <Button style="background: #999999; color: white;font-weight: bolder" @click="addAreaDialog=false">CANCEL</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {ADD_AREA, UPDATE_AREA, DELETE_AREA} from '../../graphql/mutations/area'
    import {GET_AREAS} from '../../graphql/queries/area'
    import {SUBSCRIBE_GET_AREAS} from '../../graphql/subscription/area'
    import { SEARCH_CITY2, SEARCH_AREAGROUP} from '../../graphql/queries/territories'
    import {generateUUID} from '../../Constants/Constant'
    import ValidationRules from '../../Constants/ValidationRules'
    export default {
        apollo: {
            area: {
                query: GET_AREAS,
                variables() {
                    return {
                        cityId: this.city.id,
                        areaGroupId: this.areaGroup.id
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_GET_AREAS,
                    variables() {
                        return {
                            cityId: this.city.id,
                            areaGroupId: this.areaGroup.id
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.areaArr = subscriptionData.data.area;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.areaArr = data.area;
                    }
                }
            },
            city: {
                query: SEARCH_CITY2,
                variables() {
                    return {
                        cityFilter: this.cityFilter
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.cityArr = data.city;
                    }
                }
            },
            areaGroups: {
            query: SEARCH_AREAGROUP,
            variables() {
                return {
                    groupFilter: this.groupFilter
                }
            },
            result ({ data, loading }) {
                if (!loading) {
                    this.groupArr = data.areaGroups;
                }
            }
        }
      },
        name: "Area",
        props:['city','areaGroup'],
        data: function(){
            return{
                mutation_ADD_AREA: ADD_AREA,
                mutation_UPDATE_AREA: UPDATE_AREA,
                mutation_DELETE_AREA: DELETE_AREA,
                areaArr: [],
                areaHeaders: [
                    {title: 'Area', key: 'area'},
                    {title: 'Area Group', key: 'areaGroup',
                        render:(h, params) => {return h('div',params.row.areaGroup.name)}},
                    {title: 'City', key: 'city',
                        render:(h, params) => {return h('div',params.row.city.city)}},
                    {title: ' ', slot: 'action', width: 80}
                ],
                addAreaDialog: false,
                cityArr: [],
                groupArr: [],
                areaForm:{
                    id: '',
                    area: '',
                    groupId: '',
                    cityId: '',
                    groupName: '',
                    cityName: ''
                },
                ruleAreaForm:{
                    area: ValidationRules.textField('Area'),
                    groupName: ValidationRules.textField('Area Group'),
                    cityName: ValidationRules.textField('City')
                },
                editMode: false,
                loading: false
            }
        },
        computed: {
            cityFilter () {
                return '%' + this.areaForm.cityName + '%'
            },
            groupFilter () {
                return '%' + this.areaForm.groupName + '%'
            }
        },
        methods:{
            reset: function(){
                this.$refs['areaForm'].resetFields();
            },
            onAddArea(){
                this.reset();
                this.editMode = false;
                this.areaForm.groupId = this.areaGroup.id;
                this.areaForm.cityId = this.city.id;
                this.areaForm.groupName = this.areaGroup.name;
                this.areaForm.cityName = this.city.city;
                this.addAreaDialog = true;
            },
            addArea(){
                this.loading = true;
                this.$refs['areaForm'].validate((valid) => {
                    if (valid) {
                        this.insertArea();
                    }else{
                        this.loading = false
                    }
                })
            },
            async insertArea(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_AREA,
                    variables: {
                        id: generateUUID(),
                        area: this.areaForm.area,
                        groupId: this.areaForm.groupId,
                        cityId: this.areaForm.cityId
                    }
                })
                if(response.data.insert_area.returning[0].id){
                    this.$Message.success('New Area added successfully!');
                    this.reset();
                    this.loading = false
                    this.addAreaDialog = false;
                }
            },
            onEditArea(areaData){
                this.reset();
                this.areaForm.id = areaData.id;
                this.areaForm.area = areaData.area;
                this.areaForm.groupId = areaData.areaGroup.id;
                this.areaForm.cityId = areaData.city.id;
                this.areaForm.groupName = areaData.areaGroup.name;
                this.areaForm.cityName = areaData.city.city;
                this.editMode = true;
                this.addAreaDialog = true;
            },
            modifyArea(){
                this.$refs['areaForm'].validate((valid) => {
                    if (valid) {
                        this.updateArea();
                    }
                })
            },
            async updateArea(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_AREA,
                    variables: {
                        areaId: this.areaForm.id,
                        area: this.areaForm.area,
                        groupId: this.areaForm.groupId,
                        cityId: this.areaForm.cityId
                    }
                })
                if(response.data){
                    this.$Message.success('Area updated successfully!');
                    this.reset();
                    this.addAreaDialog = false;
                }
            },
            onDeleteArea(areaId){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to delete Area ?</p>',
                    loading: true,
                    onOk: () => {
                        this.deleteArea(areaId, this.$Modal)
                    }
                });
            },
             deleteArea(areaId, callback){
                this.$apollo.mutate({
                    mutation: this.mutation_DELETE_AREA,
                    variables: { areaId: areaId }
                }).then(function(response){
                    callback.remove();
                    this.$Message.success('Area deleted successfully!');
                }).catch(function(err){
                    callback.remove();
                })
            }
        }
    }
</script>

<style scoped>
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    /deep/ .ivu-table td {
        border-bottom: 0px;
    }
    /deep/ .ivu-table th {
        border-bottom: 0px;
    }
    /deep/ .ivu-table-wrapper {
        position: unset !important;
        border: 0px ;
    }
    .add-icon-area{
        float: right;
        font-size: 22px;
    }
</style>